
enum ChatsPoolEvent {
  ANY_CHAT_UPDATE = 'ANY_CHAT_UPDATE',
  ANY_CHAT_PARTIAL_UPDATE = 'ANY_CHAT_PARTIAL_UPDATE',
  CHANNEL_COUNTER_RESET = 'CHANNEL_COUNTER_RESET',
}

export default ChatsPoolEvent;
